import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { jwtDecode } from 'jwt-decode';
import { validateGoogleToken, refreshGoogleToken, validateMojoToken, refreshMojoToken } from "../../services/authService";
import ProtectedRouteSubscriptionGate from "./ProtectedRouteSubscriptionGate";

const ProtectedRoute = ({ children }) => {
  const [isValid, setIsValid] = useState(null); // null = loading, true/false = validated

  const token = localStorage.getItem("access_token");
  const refreshToken = localStorage.getItem("refresh_token");
  const provider = localStorage.getItem("auth_provider"); // 'google' or 'mojoauth'

  const isTokenExpired = (token) => {
    try {
      const decoded = jwtDecode(token);
      return decoded.exp < Math.floor(Date.now() / 1000);
    } catch {
      return true;
    }
  };

  useEffect(() => {
    const validateToken = async () => {
      if (!token) return setIsValid(false);

      if (isTokenExpired(token)) {
        if (!refreshToken) return setIsValid(false);

        try {
          let res;
          if (provider === "google") {
            res = await refreshGoogleToken(refreshToken);
            if (res.data.id_token) {
              localStorage.setItem("access_token", res.data.id_token);
              setIsValid(true);
              return;
            }
          } else if (provider === "mojoauth") {
            res = await refreshMojoToken(refreshToken);
            if (res.data.access_token) {
              localStorage.setItem("access_token", res.data.access_token);
              setIsValid(true);
              return;
            }
          }
          throw new Error("Refresh failed");
        } catch (err) {
          console.error("Refresh failed:", err.message);
          localStorage.removeItem("access_token");
          localStorage.removeItem("refresh_token");
          localStorage.removeItem("auth_provider");
          setIsValid(false);
          return;
        }
      } else {
        try {
          let res;
          if (provider === "google") {
            res = await validateGoogleToken(token);;
          } else if (provider === "mojoauth") {
            res = await validateMojoToken(token);
          }

          setIsValid(res?.data?.valid || false);
        } catch (err) {
          console.error("Token validation failed:", err.message);
          setIsValid(false);
        }
      }
    };

    validateToken();
  }, [token, provider, refreshToken]);

  // --- JWT gate only; subscription expiry / plan access is handled below ---
  if (isValid === null) return null; // Or a loading spinner
  if (isValid === false) return <Navigate to="/" replace />;

  return (
    <ProtectedRouteSubscriptionGate>
      {children}
    </ProtectedRouteSubscriptionGate>
  );
};

export default ProtectedRoute;
